import ComicCard from '@/components/feature/ComicCard';
import type { Comic } from '@/mocks/comics';

interface ComicGridProps {
  title: string;
  subtitle?: string;
  comics: Comic[];
  viewAllLink?: string;
}

export default function ComicGrid({ title, subtitle, comics, viewAllLink }: ComicGridProps) {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              {title}
            </h2>
            {subtitle && (
              <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <a
              href={viewAllLink}
              className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-s-line"></i>
            </a>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {comics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}